import React from 'react'
import styled, { keyframes, css } from 'styled-components'

const animate = (props) => keyframes`
  0% {
    color: ${(props.theme && props.theme.colors && props.theme.colors.primary) || '#E87721'}
  }

  100% {
    color: ${(props.theme && props.theme.colors && props.theme.colors.secondary) || '#F1F1F1'}
  }
`

const dots = keyframes`
  0% {
    content: 'Lo'
  }

  33% {
    content: 'Load'
  }

  66% {
    content: 'Loadin'
  }

  100% {
    content: 'Loading...'
  }
`

const colorChangeAnimation = css`
  animation: ${(props) => animate(props)} 3s infinite alternate;
`

const Loading = styled.div`
  position: relative;
  padding-left: 5px;
  font-size: 2em;
  font-weight: bold;
  color: ${({ theme }) => (theme && theme.colors && theme.colors.primary) || '#E87721'};
  ${colorChangeAnimation}

  &::after {
    content: '';
    animation: ${dots} 3s infinite linear alternate;
    // display: inline-block;displaydisplay
    // position: absolute;positionposition
    // left: 0;leftleft
    // top: calc(50% - .75em);toptop
    // height: 1.5em;heightheight
    // width: 1px;widthwidth
    // background-color: ${({ theme }) => (theme && theme.colors && theme.colors.secondary) || '#F1F1F1'}background-colorbackground-color
  }
`

// eslint-disable-next-line react/display-name
export default () => <Loading />
